import xmail from "../../../api/api";
import OrgContacts from "../../core/common/OrgContacts";

export default {
    data: function () {
        return {
            //自动搜索收件人输入值
            autocompleteItems: [],
            autocompleteFilterText: ""
        };
    },
    computed: {
        /**
         * 是否显示搜索结果
         * @returns {boolean}
         */
        enableAutocomplete() {
            return this.autocompleteFilterText !== "";
        },
        enableAutocompleteRec() {
            const ret = this.form.receiver !== "";
            if (ret) {
                this.$refs.writeMailAutocompleteRec.style.top = '' + (5 + this.$refs.recDiv.clientHeight) + 'px';
            }
            return ret;
        },
        enableAutocompleteCc() {
            const ret = this.form.cc !== "";
            if (ret) {
                this.$refs.writeMailAutocompleteCc.style.top = '' + (5 + this.$refs.ccDiv.clientHeight) + 'px';
            }
            return ret;
        },
        enableAutocompleteBcc() {
            const ret = this.form.bcc !== "";
            if (ret) {
                this.$refs.writeMailAutocompleteBcc.style.top = '' + (5 + this.$refs.bccDiv.clientHeight) + 'px';
            }
            return ret;
        },
    },
    methods: {
        /**
         * 搜索框输入（截流）
         */
        onChangeAutocompleteFilterText: (function () {
            function getdepartsLabel(node) {
                if (node && node.name) {
                    let parentLabel = getdepartsLabel(node.parent)
                    let ignoredepartsLabel = node.id === 'def' || node.id === 'orgRoot' || node.type === xmail.enums.OrgTreeNodeType.ORG_ROOT;
                    return ignoredepartsLabel ? parentLabel : ("" === parentLabel ? '' : parentLabel + '/') + node.name;
                }
                return "";
            }

            return _.debounce(function (event) {
                let self = this;
                //选择联想完成目标
                let ipt = event.target.dataset.ipt;
                let haveAddrs = [];
                switch (ipt) {
                    case 'rec':
                        self.autocompleteFilterText = self.form.receiver;
                        haveAddrs = self.form.receiverLabel.map(item => item.org);
                        break;
                    case 'cc':
                        self.autocompleteFilterText = self.form.cc;
                        haveAddrs = self.form.ccLabel.map(item => item.org);
                        break;
                    case 'bcc':
                        self.autocompleteFilterText = self.form.bcc;
                        haveAddrs = self.form.bccLabel.map(item => item.org);
                        break;
                }
                const text = self.autocompleteFilterText = event.target.value;
                let acTrees = [];
                if (this.orgTrees) {
                    acTrees = [...this.orgTrees, ...this.persTrees]
                } else {
                    acTrees = this.persTrees
                }
                let items = OrgContacts.orgTreeCollect(acTrees, function (node) {
                    if (node.email && !haveAddrs.includes(node.email)) {
                        if (node.name.indexOf(text) >= 0 || node.email.indexOf(text) >= 0 || node.pinyin.indexOf(text) >= 0) {
                            let item = OrgContacts.autocompleteLabel(node.name + '<' + node.email + '>', text);
                            item.name = node.name;
                            item.email = node.email;
                            item.id = node.id;
                            item.departsLabel = getdepartsLabel(node.parent);
                            return item;
                        }
                    }
                }, OrgContacts.Constant.MAX_AUTOCOMPLETE_FILTER_RESLUT_COUNT);
                self.autocompleteItems.splice(0, self.autocompleteItems.length);
                items.forEach(function (item) {
                    self.autocompleteItems.push(item);
                })
            }, 200, {trailing: true});
        })(),

        /**
         * 对搜索出来结果进行勾选
         */
        toggleAutocompleteItem(item) {
            item.selected = !item.selected;
        },

        /**
         * 关闭搜索框
         */
        clearAutocomplete(type) {
            switch (type) {
                case 'rec':
                    this.form.receiver = "";
                    break;
                case  'cc':
                    this.form.cc = "";
                    break;
                case 'bcc':
                    this.form.bcc = "";
                    break;
                default:
                    this.autocompleteFilterText = "";
            }
            // this.autocompleteFilterText = "";
            this.autocompleteItems.splice(0, this.autocompleteItems.length);
        },

    }
}



// WEBPACK FOOTER //
// ./src/components/views/member_selector/BaseAutocomplete.js